<div *ngIf="!loading">

  <div *ngFor="let subscription of group.subscriptions;last as isLast">
    <!-- <oc-paused-plan *ngIf="subscription.isPaused" plan="subscription" is-upcoming="false"></oc-paused-plan> -->
    <!-- <oc-paused-plan *ngIf="subscription.upcomingPlans[0].isPaused" plan="subscription" is-upcoming="true"></oc-paused-plan>-->
    <ng-container *ngIf="subscription.templateType === 'SPECIAL_TRIAL'">
      <ul>
        <webu-special-trial *ngIf="subscription.showDataUsage"  [isVehicleOverviewPage]="isVehicleOverviewPage" [subscription]="subscription" [userRole]="userRole" [serviceUsage]="serviceUsage">
        </webu-special-trial>
        <webu-special-trial *ngIf="!subscription.showDataUsage" [isVehicleOverviewPage]="isVehicleOverviewPage" [subscription]="subscription" [userRole]="userRole">
        </webu-special-trial>
      </ul>
    </ng-container>
    <ng-container *ngIf="subscription && subscription.upcomingPlans && !subscription.isPaused && !subscription.upcomingPlans[0]?.isPaused && subscription.templateType !== 'SPECIAL_TRIAL'">
      <ul *ngIf="subscription.activePlans && subscription.activePlans.length > 0" class="mt-8">
        <div>
          <li>
            <webu-subscriptions
              [group]="group"
              [subscription]="subscription"
              [userRole]="userRole"
              [isVehicleOverviewPage]="isVehicleOverviewPage"
              [serviceUsage]="serviceUsage">
            </webu-subscriptions>
            <hr class="cit mb-4" *ngIf="subscription.upcomingPlans.length > 0">
          </li>

          <div *ngIf="!subscription.templateType.includes('TRIAL') && subscription.upcomingPlans.length > 0">
            <li *ngFor="let upcomingSubscription of subscription.upcomingPlans; last as lastUpcoming; index as upcomingIndex">
              <webu-subscriptions
                [group]="group"
                [subscription]="subscription"
                [upcomingIndex]="upcomingIndex"
                [userRole]="userRole"
                [isFuture]="true"
                [isVehicleOverviewPage]="isVehicleOverviewPage">
              </webu-subscriptions>
                <hr class="cit" *ngIf="!lastUpcoming">
            </li>
          </div>

          <li *ngIf="subscription.templateType.includes('TRIAL') && subscription.upcomingPlans.length > 0">
            <webu-subscriptions
              [group]="group"
              [subscription]="subscription"
              [isTrialSecondItem]="true"
              [userRole]="userRole"
              [isVehicleOverviewPage]="isVehicleOverviewPage">
            </webu-subscriptions>
          </li>

          <li class="" *ngIf="subscription.shopPromo">
            <webu-subscriptions
              [group]="group"
              [subscription]="subscription"
              [isTrialSecondItem]="true"
              [userRole]="userRole"
              [isVehicleOverviewPage]="isVehicleOverviewPage">
            </webu-subscriptions>
          </li>

        </div>
      </ul>
      <ul *ngIf="!subscription.activePlans && subscription.upcomingPlans && subscription.upcomingPlans.length > 0" class="mt-8">
        <div>
          <li  *ngFor="let upcomingSubscription of subscription.upcomingPlans; index as upcomingIndex">
            <webu-subscriptions
              [group]="group"
              [subscription]="subscription"
              [upcomingIndex]="upcomingIndex"
              [isFuture]="true"
              [userRole]="userRole"
              [isVehicleOverviewPage]="isVehicleOverviewPage">
            </webu-subscriptions>
            <hr class="cit mb-4" *ngIf="subscription.upcomingPlans.length > 1">
          </li>
          <li *ngIf="subscription.templateType.includes('TRIAL')">
            <webu-subscriptions
              [group]="group"
              [subscription]="subscription"
              [isTrialSecondItem]="true"
              [userRole]="userRole"
              [isVehicleOverviewPage]="isVehicleOverviewPage">
            </webu-subscriptions>
          </li>
        </div>
      </ul>
    </ng-container>
    <hr class="cit mb-4" *ngIf="!isLast">
  </div>

  <hr class="cit2 mt-6 mb-6">
</div>
